namespace Matrix.Rebalancer {
    export namespace ModellingViewFormatService {
        export const baseUrl = 'Rebalancer/ModellingViewFormat';

        export declare function Create(request: Serenity.SaveRequest<ModellingViewFormatRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ModellingViewFormatRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ModellingViewFormatRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ModellingViewFormatRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/ModellingViewFormat/Create",
            Update = "Rebalancer/ModellingViewFormat/Update",
            Delete = "Rebalancer/ModellingViewFormat/Delete",
            Retrieve = "Rebalancer/ModellingViewFormat/Retrieve",
            List = "Rebalancer/ModellingViewFormat/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ModellingViewFormatService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
